<template>
     <v-dialog v-if="screener.chat_room" :value="handleDialogBox" width="80%" persistent >
        <v-card>
            <v-card-title class="title">
                {{ $t('screener_chat_room.chat_room_.configurations_box.title') }}
                <v-spacer></v-spacer>
                <v-btn @click="$emit('handleClose')" icon dark>
                    <v-icon color="error">$vuetify.icons.rms_close</v-icon>
                </v-btn>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-divider></v-divider>
            <!-- Tabs To show Members and Room Configurations -->
            <v-card-text class="body-1">
                <div class="grey lighten-4">
                    <div class="">
                        <v-data-table
                            v-model="selected"
                            :headers="table_headers"
                            :items="chatRoomMembers.data"
                            v-bind:pagination.sync="pagination"
                            :total-items="chatRoomMembers.total"
                            :rowsPerPageItems="[25]"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-xs-left">{{ props.index + 1 }}</td>
                                    <td class="text-xs-left">
                                        <img class="profile-img"  :src="props.item.profile_image || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'"/>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.name }}</td>
                                    <td class="text-xs-left">{{ props.item.email }}</td>

                                    <td class="text-xs-left">
                                        <template>
                                            <v-chip v-if="props.item.is_reported" class="mx-0" small color="error" outline>
                                                {{ $t('screener_chat_room.chat_room_.configurations_box.member_status_reported') }}
                                            </v-chip>
                                            <v-chip v-else-if="props.item.status" class="mx-0" small color="success" outline>
                                                {{ $t('screener_chat_room.chat_room_.configurations_box.member_status_active') }}
                                            </v-chip>
                                            <v-chip v-else class="mx-0" small color="error" outline>
                                                {{ $t('screener_chat_room.chat_room_.configurations_box.member_status_inactive') }}
                                            </v-chip>
                                        </template>
                                    </td>
                                    <!-- <td class="text-xs-left">
                                        <v-switch
                                            hide-details
                                            v-model="props.item.is_reported"
                                            flat
                                            @change="handleReportingSwitcher(props.item)"
                                        ></v-switch>
                                    </td> -->
                                </tr>
                            </template>
                            <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">
                                    {{ $t("rms.alert.search_not_found") }}
                                </v-alert>
                            </template>
                        </v-data-table>
                    </div>
                    <!-- <v-tabs
                        v-model="parentTabItem"
                        color="transparent"
                        slider-color="primary"
                        grow
                    >
                        <v-tab href="#chatroom_members">
                            {{ $t('screener_chat_room.chat_room_.configurations_box.tab_member_title') }}
                            <v-chip
                                class="ma-2"
                                :input-value="active"
                                filter
                            >
                               2
                            </v-chip>
                        </v-tab>
                        <v-tab href="#configurations">
                            {{ $t('screener_chat_room.chat_room_configurations_btn_title') }}
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="parentTabItem">
                        <v-tab-item value="chatroom_members">
                            
                        </v-tab-item>
                        <v-tab-item value="configurations">
                            <div class="configuration-container">
                                <v-layout column wrap>
                                    <v-flex xs12 md6 lg6>
                                        <v-text-field
                                            class="mb-2"
                                            id="participants_allowed"
                                            :label="$t(`screener_chat_room.chat_room_participants_allowed_label`)"
                                            name="participants_allowed"
                                            color="primary"
                                            prepend-icon="$vuetify.icons.rms_company_members"
                                            type="text"
                                            v-model="screener.chat_room.max_members"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm12>
                                        <v-checkbox
                                            class="mt-0"
                                            :label="$t(`screener_chat_room.chat_room_enabled_group_chat_label`)"
                                            color="primary"
                                            v-model="screener.chat_room.group_chat_enabled"
                                        />
                                    </v-flex>
                                    <v-flex sx12 sm12>
                                        <div class="my-2">
                                            <v-btn
                                                color="error"
                                                dark
                                                large
                                                @click="updateChatRoomConfigurations"
                                            >
                                                {{ $t('rms.button.update') }}
                                            </v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-tab-item>
                    </v-tabs-items> -->
                </div>
        
            </v-card-text>
            <v-divider></v-divider>
        </v-card>
        <ConfirmationDialogBox
            :title="reportingDialog.title"
            :dialog="reportingDialog.visible"
            :yesBtnText="reportingDialog.yesBtnText"
            :noBtnText="reportingDialog.noBtnText"
            @confirm="handleConfirmation(reportingDialog.action)"
            @cancel="resetReportingDialog"
        >
            <div class="subheading greyDarken3--text" v-if="reportingDialog.content && reportingDialog.content.length">
                {{ reportingDialog.content }}
            </div>
        </ConfirmationDialogBox>
        </v-dialog>
</template>

<script>
import DEFINES from "@/defines";
import ChatRoomService from "@/services/ChatRoomService";
import ConfirmationDialogBox from '@/components/dialogBox/DynamicConfirmationBox';
import i18n from '@/i18n';

export default {
    name: "ChatRoomConfiguartionDialog",
    props: {
        handleDialogBox: {
            type: Boolean,
            default:false
        },
        screener: {
            type: Object,
        }
    },
    watch: {
        screener: {
            handler(newData) {
                this.$emit("update:screener", this.screener);
            },
            deep: true,
            immediate: true
        },
        pagination: {
            handler() {
                if (this.$route.params.screener_id) this.getDataFromApi();
            },
            deep: true,
        },
    },
    data() {
        return {
            parentTabItem: 'chatroom_members',
            max_members: (this.screener.chat_room) ? this.screener.chat_room.max_members : DEFINES.CHAT_ROOM.DEFAULT_PARTICIPANTS,
            group_chat_enabled: (this.screener.chat_room) ?  this.screener.chat_room.group_chat_enabled : false,
            selected: [],
            chatRoomMembers: {
                data: [],
            },
            table_headers: [
                { text: "SN", align: "left", sortable: false },
                {
                    text: "Avatar",
                    align: "left",
                    sortable: false,
                    value: "avatar",
                },
                {
                    text: "Name",
                    sortable: false,
                    align: "left",
                    value: "name",
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                },
                {
                    text: "Status",
                    align: "left",
                    sortable: false,
                    value: "status",
                },
                // {
                //     text: "Report",
                //     align: "left",
                //     sortable: false,
                //     value: "created_at",
                // },
            ],
            pagination: {
                sortBy: "created_at",
                descending: true,
                rowsPerPage: 25,
                page: 1,
            },
            reportingDialog: {
                visible: false,
                title: null,
                yesBtnText: null,
                noBtnText: null,
                content: null,
                action: null,
            },
            reportingMember: null,
        }
    },
    components: {
        ConfirmationDialogBox,
    },
    created() {
        this.getDataFromApi()
    },
    methods: {
        async updateChatRoomConfigurations()
        {
            var payload = {
                allow_chat_room:true,
                ...this.screener.chat_room
            }
            try {
                var response = await this.$store.dispatch("screener/updateScreenerChatroom", payload);
                this.screener.chat_room = response.chatRoom;
                this.parentTabItem = "chatroom_members";
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error",
                });
            }
        },
        async getDataFromApi() {
            try {
                // Pagination
                const {sortBy, descending, page, rowsPerPage} = this.pagination;
                var offset = this.getPaginationOffset(rowsPerPage, page);

                // Payload
                let payload = {
                    offset: offset,
                    limit: rowsPerPage,
                    sort: sortBy,
                    sorting_order: descending,
                    screener_id: this.$route.params.screener_id,
                    chat_room_id: this.screener.chat_room.id
                };
                var response = await this.$store.dispatch("chatRoom/listMembers", payload);
                const members = response.chatRoomMembers.data;

                // Preload profile images
                const membersWithImages = await Promise.all(
                    members.map(async (member) => {
                        const profileImage = await this.__memberProfileImage(member.id);
                        return { ...member, profile_image: profileImage };
                    })
                );

                this.chatRoomMembers.data = membersWithImages;
                this.chatRoomMembers.total = response.chatRoomMembers.total;
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: this.DEFINES.SNACKBAR_ERROR_COLOR,
                });
            }
        },
        getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
        async __memberProfileImage(memberId) {
            var member = await ChatRoomService.__getMemberDetail(this.screener.chat_room.chat_room_id, memberId);
            return ((member && member.profile_image)?(member.profile_image):null);
        },
        handleReportingSwitcher(member) {
            this.reportingMember = member;
            if (this.reportingMember.is_reported) {
                this.openReportingDialog(
                    i18n.t('screener_chat_room.report_confirmation.title'),
                    i18n.t('rms.buttons.yes'),
                    i18n.t('rms.buttons.no'),
                    i18n.t('screener_chat_room.report_confirmation.desc', {email:member.email}),
                    'enableReporting',
                );
            } else {
                this.openReportingDialog(
                    i18n.t('screener_chat_room.unreport_confirmation.title'),
                    i18n.t('rms.buttons.yes'),
                    i18n.t('rms.buttons.no'),
                    i18n.t('screener_chat_room.unreport_confirmation.desc', {email:member.email}),
                    'disableReporting',
                );
            }
        },
        openReportingDialog(title, yesBtnText, noBtnText, content, action) {
            this.reportingDialog.visible = true;
            this.reportingDialog.title = title;
            this.reportingDialog.yesBtnText = yesBtnText;
            this.reportingDialog.noBtnText = noBtnText;
            this.reportingDialog.content = content;
            this.reportingDialog.action = action;
        },
        resetReportingDialog() {
            this.reportingDialog.visible = false;
            this.reportingDialog.title = null;
            this.reportingDialog.yesBtnText = null;
            this.reportingDialog.noBtnText = null;
            this.reportingDialog.content = null;
            this.reportingDialog.action = null;
            this.reportingMember.is_reported = !this.reportingMember.is_reported;
        },
        handleConfirmation(handlerName) {
            this[handlerName]();
        },
        async enableReporting() {
            this.reportingMember.is_reported = true;
            await this.updateMember();
            this.reportingDialog.visible = false;
        },
        async disableReporting() {
            this.reportingMember.is_reported = false;
            await this.updateMember();
            this.reportingDialog.visible = false;
        },
        async updateMember()
        {
            let payload = {
                chat_room_id: this.screener.chat_room.id,
                member_id: this.reportingMember.id,
                ...this.reportingMember
            };
            try {
                var response = await this.$store.dispatch("chatRoom/updateMember", payload);
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: this.DEFINES.SNACKBAR_ERROR_COLOR,
                });
            }
        }
    }
}
</script>

<style scoped>
.configuration-container {
    min-height: 400px;
    padding: 60px 10px 10px 10px;
}
.profile-img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>